import React, { useEffect } from 'react';
import style from './style.module.css';

const CustomNotification = ({ 
  message, 
  show, 
  onClose,
  bgColor = "bg-blue-500", 
  textColor = "text-white", 
  position = "top-4 right-4", 
  padding = "p-4", 
  borderRadius = "rounded-lg", 
  shadow = "shadow-lg",
  extraClasses = ""
}) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose(); 
      }, 3000);
      return () => clearTimeout(timer); 
    }
  }, [show, onClose]);

  if (!show) return null;
  
  return (
    <div className={`${style.notification} fixed ${position} ${bgColor} ${textColor} ${padding} ${borderRadius} ${shadow} ${extraClasses}`}>
      <span>{message}</span>
    </div>
  );
};

export default CustomNotification;
